module.exports = __webpack_public_path__ + "static/media/cc.722f0576.svg";